export default __webpack_public_path__ + "static/media/telkomsel-logo.e79a3872.png";